import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const twoColumnTextFn = /* @__PURE__ */ createRecipe('two-column-text', {}, [])

const twoColumnTextVariantMap = {}

const twoColumnTextVariantKeys = Object.keys(twoColumnTextVariantMap)

export const twoColumnText = /* @__PURE__ */ Object.assign(memo(twoColumnTextFn.recipeFn), {
  __recipe__: true,
  __name__: 'twoColumnText',
  __getCompoundVariantCss__: twoColumnTextFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: twoColumnTextVariantKeys,
  variantMap: twoColumnTextVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, twoColumnTextVariantKeys)
  },
  getVariantProps: twoColumnTextFn.getVariantProps,
})